import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSelectCodegen = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#4A5666",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		transform: "translate(1 1)",
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 8.5,
			r: 8.5
		}), /* @__PURE__ */ _jsx("path", { d: "m5 9 2.5 2.5L12 6" })]
	})
});
export default SvgSelectCodegen;
